// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { mainNavigationStyles } from "@sc/Overrides/Widgets/Header/MainNavigation";
import ArrowDown from "@sc/XDL/Icons/ArrowDown";
import { color, layoutContainer } from "@sc/XDL/Utilities";
import { css } from "styled-components";

mainNavigationStyles.container = {
    css: css`
        color: ${color("common.background")};
        display: flex;
        gap: 24px;
        ${layoutContainer}
        &&&& {
            padding-left: 16px;
            padding-right: 16px;
        }
    `,
};

mainNavigationStyles.menuItem = {
    css: css`
        display: flex;
        align-items: center;
        height: auto;
        padding: 4px 8px;
        &&&:hover {
            background-color: ${color("common.ui12")};
            border-radius: 4px;
            ${TypographyStyle} {
                color: ${color("text")};
            }
        }
        &:not(:disabled):hover {
            &,
            & > ${TypographyStyle} {
                text-decoration: none;
            }
        }
    `,
};
mainNavigationStyles.menuItemTypography = {
    color: "text",
    size: 14,
    weight: "bold",
    css: css`
        line-height: 22px;
        display: flex;
        align-items: center;
        gap: 8px;
    `,
};

mainNavigationStyles.menuItemIcon = {
    src: ArrowDown,
    size: 13,
    css: css`
        width: 9px;
        margin: 0;
    `,
};

mainNavigationStyles.itemWrapper = {
    css: css`
        &.quick-order-wrapper {
            margin-left: auto;
        }
    `,
};

mainNavigationStyles.cascadingMenu = {
    cssOverrides: {
        fancyScrollStyle: {
            css: css`
                background: ${getColor("common.background")};
                padding-right: 4px;
                outline: 1px solid ${getColor("common.border")};
                height: 100%;
            `,
        },
    },
};
